/**
 * Contexto de la sección de auditoría.
 *
 * Separado del componente por la misma razón que `closingContext.ts`: un
 * archivo que exporta componentes y hooks a la vez rompe el refresco en
 * caliente de Vite.
 */

import { useOutletContext } from "react-router-dom";
import type { Config, SessionInfo } from "../api/types";

export interface AuditContext {
  config: Config;
  session: SessionInfo;
}

export function useAudit(): AuditContext {
  return useOutletContext<AuditContext>();
}
